/*#__PURE__*/ export default JSON.parse('{"key":"vision","type":"root","items":[{"key":"cacheConfig","def":true,"type":"bool"}]}');